<template>
  <content-items-list
    content-type="files"
    content-type-singular="file"
    content-name="Files"
    content-name-singular="File"
  />
</template>

<script>
import ContentItemsList from '@/views/content-item/content-items-list/ContentItemsList.vue'

export default {
  components: {
    ContentItemsList,
  },
}
</script>

<style scoped>

</style>
